<template>
  <el-popover ref="popoverRef"
              placement="bottom"
              popper-class="cus-no-pd-popover"
              :width="580"
              trigger="click">
    <template #reference>
      <div class="more-required-select">
        More Required
        <span style="" class="icon-triangle iconfont" />
      </div>
    </template>
    <SpForm ref="moreRequiredRef">
      <span class="font20 icon-delete iconfont mg-l-10 pointer sp-color-1" @click="clearModel" />
      <div class="font12">
        <div class="item">
          <span class="title">{{ $l('Geared') }}:</span>
          <div class="input">
            <div class="flex-al-center flex-jc-bt">
              <div style="width: 66px">
                <div class="flex-jc-bt">
                  <SpInput v-model="moreRequired.swlRequired" class="flex-1" :height="16" type="bottomBorder1"
                           placeholder=""
                           name="swlRequired"
                           :text-style="{fontSize: '12px', textAlign: 'center', paddingRight: '0px', textIndent: '0'}" />
                  <div class="sp-color-18">MT</div>
                </div>
              </div>
              <div class="" style="width: 135px">
                <div class="flex-jc-bt">
                  <div class="mg-r-10 sp-color-11">Younger than</div>
                  <SpInput v-model="moreRequired.ageMax" class="border-input-lr flex-1" :height="16"
                           type="bottomBorder1" name="ageMax"
                           placeholder="" :text-style="{fontSize: '12px', textAlign: 'center', paddingRight: '0px', textIndent: '0'}" />
                  <div class="sp-color-18">Y.O.</div>
                </div>
              </div>
              <div class="" style="width: 119px">
                <div class="flex-jc-bt">
                  <div class="mg-r-10 sp-color-11">Older than</div>
                  <SpInput v-model="moreRequired.ageMin" class="border-input-lr flex-1" :height="16" type="bottomBorder1"
                           placeholder="" name="ageMin"
                           :text-style="{fontSize: '12px', textAlign: 'center', paddingRight: '0px', textIndent: '0'}" />
                  <div class="sp-color-18">Y.O.</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="item">
          <span class="title">{{ $l('DeckersInHold') }}</span>
          <div class="input">
            <SpSelect v-model="moreRequired.deckTypeId" name="deckTypeId" class="font-12-select match-filter-select" :width="1" :height="30" type="grayBorder18"
                      :text-style="{fontSize: '12px', textAlign: 'left', textIndent: 0, paddingLeft: '10px'}"
                      @change="(value,labels)=> deckTypeLabels = labels">
              <div v-for="(shipDeck, key) in shipDeckType">
                <p class="sp-color-7 text-center">{{ key }}</p>
                <SpSelectOption v-for="item in shipDeck" :key="item.id" :label="item.name" :value="item.id" />
              </div>
            </SpSelect>
          </div>
        </div>
        <div class="item">
          <span class="title">{{ $l('HoldType') }}</span>
          <div class="input">
            <SpSelect v-model="moreRequired.holdTypeId" name="holdTypeId" class="font-12-select match-filter-select" :width="1" :height="30" type="grayBorder18"
                      :text-style="{fontSize: '12px', textAlign: 'left', textIndent: 0, paddingLeft: '10px'}"
                      @change="(value,labels)=> shipHoldLabels = labels">
              <div v-for="(shipHold, key) in shipHoldType">
                <p class="sp-color-7 text-center">{{ key }}</p>
                <SpSelectOption v-for="item in shipHold" :key="item.id" :label="item.name" :value="item.id" />
              </div>
            </SpSelect>
          </div>
        </div>
        <div class="item">
          <span class="title">{{ $l('ShipTypeByCargo') }}</span>
          <div class="input">
            <SpSelect v-model="moreRequired.cargoTypeId" name="cargoTypeId" class="font-12-select match-filter-select" :width="1" :height="30" type="grayBorder18"
                      :text-style="{fontSize: '12px', textAlign: 'left', textIndent: 0, paddingLeft: '10px'}"
                      @change="(value,labels)=> cargoTypeLabels = labels">
              <div v-for="(shipCargo, key) in shipCargoType">
                <p class="sp-color-7 text-center">{{ key }}</p>
                <SpSelectOption v-for="item in shipCargo" :key="item.id" :label="item.name" :value="item.id" />
              </div>
            </SpSelect>
          </div>
        </div>
        <div class="item">
          <span class="title">{{ $l('ShipTypeByStructue') }}</span>
          <div class="input">
            <SpSelect v-model="moreRequired.structureTypeId" name="structureTypeId" class="font-12-select match-filter-select" :width="1" :height="30" type="grayBorder18"
                      :text-style="{fontSize: '12px', textAlign: 'left', textIndent: 0, paddingLeft: '10px'}"
                      @change="(value,labels)=> structureTypeLabels = labels">
              <div v-for="(shipStructure, key) in shipStructureType">
                <p class="sp-color-7 text-center">{{ key }}</p>
                <SpSelectOption v-for="item in shipStructure" :key="item.id" :label="item.name" :value="item.id" />
              </div>
            </SpSelect>
          </div>
        </div>
      </div>
      <div class="flex-jc-bt pd-b-50 pd-l-100 pd-r-100 pd-t-50">
        <SpButton type="cancle" circle :width="113" :height="42" @click="close">{{ $L('Cancel') }}</SpButton>
        <SpButton circle :width="113" :height="42" @click="submit">{{ $L('Submit') }}</SpButton>
      </div>
    </SpForm>
  </el-popover>
  <div class="font12 more-required sp-color-7 text-left">
    <div>
      <template v-if="moreRequiredRes?.swlRequired">
        Geared&nbsp;<span>{{ moreRequiredRes.swlRequired }}</span> MT,&nbsp;
      </template>
      <template v-if="moreRequiredRes?.ageMax">
        Younger than&nbsp;<span>{{ moreRequiredRes.ageMax }}</span> Y.O. ,&nbsp;
      </template>
      <template v-if="moreRequiredRes?.ageMin">
        Older than&nbsp;<span>{{ moreRequiredRes.ageMin }}</span> Y.O. ,&nbsp;
      </template>
      <template v-if="moreRequiredRes.deckTypeLabels">
        Deckers in Hold&nbsp;<span>{{ moreRequiredRes.deckTypeLabels }}</span> ,&nbsp;
      </template>
      <template v-if="moreRequiredRes.shipHoldLabels">
        Hold Type&nbsp;<span>{{ moreRequiredRes.shipHoldLabels }}</span> ,&nbsp;
      </template>
      <template v-if="moreRequiredRes.cargoTypeLabels">
        Ship Type(By Cargo)&nbsp;<span>{{ moreRequiredRes.cargoTypeLabels }}</span>,&nbsp;
      </template>
      <template v-if="moreRequiredRes.structureTypeLabels">
        Ship Type(By Structure)&nbsp;<span>{{ moreRequiredRes.structureTypeLabels }}</span>,&nbsp;
      </template>
    </div>
  </div>
</template>

<script>
import SpSelect from '../../../common/SpSelect'
import SpSelectOption from '../../../common/SpSelectOption'
import SpInput from '../../../common/SpInput'
import SpForm from '../../../common/SpForm'
import { ref, watch } from 'vue'
import {
  getShipCargoTypeApi,
  getShipDeckTypeApi,
  getShipHoldTypeApi,
  getShipStructureTypeApi
} from '../../../../request/APIs/so'
import SpButton from '../../../common/SpButton'
export default {
  name: 'MoreRequired',
  nameSpace: 'match.popups.filter',
  components: { SpButton, SpForm, SpInput, SpSelectOption, SpSelect },
  props: {
    defaultRequirements: {
      type: Object,
      default: {}
    }
  },

  emits: ['saveMoreRequired'],
  setup (props, ctx) {
    const popoverRef = ref(null)
    const shipStructureType = ref({})
    const shipCargoType = ref({})
    const shipHoldType = ref({})
    const shipDeckType = ref({})
    // 获取按结构划分的船舶类型选项
    const getShipStructureType = () => {
      getShipStructureTypeApi().then(res => {
        shipStructureType.value = res.data
      })
    }

    // 获取按可装货类划分的船舶类型选项
    const getShipCargoType = () => {
      getShipCargoTypeApi().then(res => {
        shipCargoType.value = res.data
      })
    }

    // 获取船舶舱型选项
    const getShipHoldType = () => {
      getShipHoldTypeApi().then(res => {
        shipHoldType.value = res.data
      })
    }

    // 获取船舶舱内甲板层数选项
    const getShipDeckType = () => {
      getShipDeckTypeApi().then(res => {
        shipDeckType.value = res.data
      })
    }
    getShipStructureType()
    getShipCargoType()
    getShipHoldType()
    getShipDeckType()

    const moreRequiredRef = ref(null)
    const moreRequired = ref({})

    const moreRequiredRes = ref({})

    watch(() => props.defaultRequirements, (val) => {
      moreRequiredRes.value = props.defaultRequirements
      moreRequired.value = props.defaultRequirements
    })
    const clearModel = () => {
      moreRequiredRef.value.clearForm()
      moreRequiredRes.value = {
        ...moreRequired.value,
        deckTypeLabels,
        shipHoldLabels,
        cargoTypeLabels,
        structureTypeLabels
      }
      ctx.emit('saveMoreRequired', { ...moreRequired.value, deckTypeLabels, shipHoldLabels, cargoTypeLabels, structureTypeLabels })
      popoverRef.value.hide()
    }
    const close = () => {
      popoverRef.value.hide()
    }
    const deckTypeLabels = ref('')
    const shipHoldLabels = ref('')
    const cargoTypeLabels = ref('')
    const structureTypeLabels = ref('')
    const show = ref(false)
    const submit = () => {
      moreRequiredRes.value = {
        ...moreRequired.value,
        deckTypeLabels,
        shipHoldLabels,
        cargoTypeLabels,
        structureTypeLabels
      }
      ctx.emit('saveMoreRequired', { ...moreRequired.value, deckTypeLabels, shipHoldLabels, cargoTypeLabels, structureTypeLabels })
      popoverRef.value.hide()
    }
    return {
      moreRequiredRef,
      moreRequired,
      show,
      shipStructureType,
      shipCargoType,
      shipHoldType,
      shipDeckType,
      deckTypeLabels,
      shipHoldLabels,
      cargoTypeLabels,
      structureTypeLabels,
      moreRequiredRes,
      clearModel,
      popoverRef,
      close,
      submit
    }
  }
}
</script>

<style scoped lang="less">
.item{
  .flex-jc-bt();
  .flex-al-center();
  &.flex-al-start {
    -webkit-align-items: flex-start;
    align-items:flex-start;
  }
  margin-bottom: @gap/2;
  flex-wrap: nowrap;
  padding-right: 20px;
  font-size: 12px;
  .title{
    color: #000000;
    width: 156px;
    text-align: right;
    box-sizing: border-box;
    padding-right: 12px;
  }
  .input{
    flex:1;
    flex-wrap: nowrap !important;
    &.wrap {
      flex-wrap: wrap !important;
    }
    .flex();
    >*{
      flex-grow: 1;
      flex-shrink: 1;
    }
    .divider{
      padding: 0 5px;
      flex-grow: 0;
      line-height: 28px;
    }
  }
}
.more-required-select{

  line-height: 10px; font-size: 12px; text-align: left; border-bottom: 1px solid #999999; width: 104px;
  .icon-triangle {
    font-size: 6px; position:relative; top: -2px; color:#000000; margin-left: 4px;
  }
}
.more-required {
  box-sizing: border-box;
  margin-top: 5px;
  height: 172px;
  background: #FFFFFF;
  padding: 20px 20px;
  box-shadow: 0px 11px 46px 5px rgba(0,0,0,0.1);
}
</style>
